import axios from 'axios'

//Default values


const mutations = {
}

const actions = {
    SAVE_SETTING: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post('settings', payload)
                .then((res) => {
                    return resolve(res);
                }).catch(error => {
                return reject(error.response.data);
            })
        })
    },
    GET_SETTING: async (context, payload) => {
        return axios.get('settings/' + payload)
            .then((res) => {
                return res.data
            })
    },
    GET_SETTINGS: async ({rootState, commit}, payload) => {
        return axios.get('settings', {
            params: {
                page: rootState.table.table.serverParams.page,
                perPage: rootState.table.table.serverParams.perPage
            }
        })
            .then((res) => {
                commit('FETCH_ITEMS', res.data)
            })
    },
    UPDATE_SETTING: async (context, payload) => {
        return axios.put('settings/' + payload.id, payload)
            .then((res) => {
                return res.data
            })
    },
    UPDATE_SETTING_OPTION: (context, payload) => {
        return new Promise((resolve, reject) => {
            let data = payload
            let config = {}
            if (payload.option === "file"){
                data = payload.formData
                config = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            }
            axios.post('settings/option/' + payload.option, data,config)
                .then((res) => {
                    context.commit('CHANGE_SETTING', res.data)
                    return resolve(res);
                }).catch(error => {
                return reject(error.response);
            })
        })
    },
    UPDATE_SETTING_MULTIPLE: (context, payload) => {
        console.log(payload);
        return new Promise((resolve, reject) => {
            axios.post('settings/option', payload)
                .then((res) => {
                    context.commit('CHANGE_SETTING', res.data)
                    return resolve(res);
                }).catch(error => {
                return reject(error.response);
            })
        })
    },
}

const getters = {}

export default {
    mutations,
    actions,
    getters
}
